module.exports = __webpack_public_path__ + "static/img/down_img07.png.87cae17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sptj/down_img07.png.png
// module id = fYQq
// module chunks = 1